
import Pdfs from "../../Pdfs";
import pdf from './arquivoPdf/certificado_node.pdf';


export default function Pdf01(){
    return(

        <Pdfs pdf={pdf} />

    )
}


/*pdf="./Pdf01/arquivoPdf/certificado_frontEnd.pdf" */